
import { Component, Vue, Prop } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import rules from "@/store/rules";
import { RegionPriceListDto } from "../../dtos/regionPriceListDto";
import { MaterialWithPriceDto } from "../../dtos/materialWithPriceDto";
import { PriceModel } from "@/dtos/priceModel";
import { WerkstoffDto } from "@/dtos/werkstoffDto";
import { MaterialPriceDto } from "@/dtos/materialPriceDto";
@Component
export default class Settings extends Vue {
	private loading: boolean = false;
	private regionPriceLists: RegionPriceListDto[] = [];
	private requiredNonNegativeNumberRule = rules.requiredNonNegativeNumberRule;
	private optionalNonNegativeNumberRule = rules.optionalNonNegativeNumberRule;
	private formValid: boolean = false;

	private async mounted() {
		await this.loadPrices();
	}

	private getEnumNameFromValue(enumValue: number) {
		return PriceModel[enumValue];
	}

	private getPlaceholder(material: MaterialWithPriceDto) {
		let standardPrice = material.modelPrices.filter(
			(mp: MaterialPriceDto) => mp.priceModel == PriceModel.Standard
		)[0].price;
		return `Erbt von Standard: ${standardPrice}`;
	}

	private get formsValid(): boolean {
		let valid = true;
		this.regionPriceLists.forEach((rp: RegionPriceListDto) => {
			rp.werkstoffe.forEach((w: WerkstoffDto) => {
				w.materials.forEach((m: MaterialWithPriceDto) => {
					m.modelPrices.forEach((mp: MaterialPriceDto) => {
						if (!mp.valid) {
							valid = false;
							console.log(
								`invalid: region=${rp.regionId} | material=${m.name} | price=${this.getEnumNameFromValue(mp.priceModel)}`
							);
						}
					});
				});
			});
		});
		return valid;
	}

	private async loadPrices() {
		try {
			this.loading = true;
			const response = await httpClient().get(`Material/GetMaterialPrices`);
			this.regionPriceLists = response.data;
		} catch {
			console.log("Loading prices failed.");
		} finally {
			this.loading = false;
		}
	}

	private async updateMaterial(material: MaterialWithPriceDto, regionId: string, valid: boolean) {
		if (!valid) {
			console.log("forms not valid");
			return;
		}
		try {
			this.loading = true;
			await httpClient().post(`Material/UpdateMaterialPrice?regionId=${regionId}`, material);
			this.$store.commit("setSnackbarText", "Änderungen erfolgreich gespeichert.");
		} catch (err) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Änderungen konnten nicht gespeichert werden."
			);
			console.log("Saving price failed.", err);
		} finally {
			this.loading = false;
		}
	}

	private async assignWerkstoffToRegion(regionId: number, werkstoff: string, available: boolean) {
		try {
			this.loading = true;
			await httpClient().post(
				`Material/AssignWerkstoffToRegion?regionId=${regionId}` +
					`&werkstoff=${werkstoff}&available=${available}`
			);
			console.log("assigned werkstoff");
			if (available) {
				this.$store.commit(
					"setSnackbarText",
					"Werkstoff erfolgreich der Region zugewiesen."
				);
			} else {
				this.$store.commit(
					"setSnackbarText",
					"Werkstoff erfolgreich aus der Region entfernt."
				);
			}
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Werkstoff konnte nicht zugewiesen werden.");
			console.log("Assigning werkstoff to region failed.", err);
		} finally {
			this.loading = false;
		}
	}

	private async assignMaterialfToRegion(regionId: number, materialId: number, active: boolean) {
		try {
			this.loading = true;
			await httpClient().post(
				`Material/AssignMaterialToRegion?regionId=${regionId}` +
					`&materialId=${materialId}&active=${active}`
			);
			console.log("assigned material");
			if (active) {
				this.$store.commit(
					"setSnackbarText",
					"Material erfolgreich der Region zugewiesen."
				);
			} else {
				this.$store.commit(
					"setSnackbarText",
					"Material erfolgreich aus der Region entfernt."
				);
			}
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Material konnte nicht zugewiesen werden.");
			console.log("Assigning material to region failed.", err);
		} finally {
			this.loading = false;
		}
	}
}
